import { render, staticRenderFns } from "./content-collapsable.vue?vue&type=template&id=929e4b8c&"
import script from "./content-collapsable.vue?vue&type=script&lang=js&"
export * from "./content-collapsable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports